import SubmitExamAPI from '@/apis/business/student/submit-exam-api.js'
import { HttpStatusCode } from '@/common/constant'
import Enumeration from '@/common/enumeration.js'
import { handleSaveMappingAnswerOneQuestion } from '@/views/pages/teacher/storage/create/common/common.js'

export default {
  namespaced: true,

  state: {
    prevQuestionIndex: -1
  },

  getters: {},

  mutations: {
    /**
     * @description set dữ liệu cho state prevQuestionIndex
     * @author PVThang
     * @param {*} state
     * @param {*} studentPackage
     */
    setPrevQuestionIndex (state, prevQuestionIndex) {
      state.prevQuestionIndex = prevQuestionIndex
    }
  },

  actions: {
    /**
     * Lưu bài kiểm tra
     * @param {*} context
     * @param {*} param
     * @author lhlong - 18/04/2022
     */
    submitExamination (context, param) {
      return new Promise((resolve, reject) => {
        SubmitExamAPI.postAsync('/submit-final', param)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
       * Lưu nháp bài kiểm tra
       * @param {*} context
       * @param {*} param
       * @author lhlong 18/04/2022
       */
    saveDraftExamOneQuestion (context, payload) {
      return new Promise((resolve, reject) => {
        const question = handleSaveMappingAnswerOneQuestion(payload)

        SubmitExamAPI.postAsync('/submit-question', question)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
